module.exports = __webpack_public_path__ + "static/media/Spinner.a08e9612.gif";